import 'bootstrap';
import 'bootstrap-touchspin';

import './responsive';
import './checkout';
import './customer';
import './listing';
import './product';
import './cart';
import './index';
import './contact';
import './components/instantsearch';
import './components/reviews';
import './modules/fractoblockplus';
import './modules/prestablog';

import Parallax from './components/parallax';
import DropDown from './components/drop-down';
import Form from './components/form';
import TopMenu from './components/top-menu';

import prestashop from 'prestashop';
import EventEmitter from 'events';

import { lazyLoadImages } from './components/images';
import { linkDecrypt } from './components/links';

import {
  createCookie,
  readCookie,
} from './components/cookies';

import './components/block-cart';

for (var i in EventEmitter.prototype) {
  prestashop[i] = EventEmitter.prototype[i];
}

$(document).ready(() => {
  const form = new Form();
  const parallax = new Parallax();

  let dropDownEl = $('.js-dropdown');
  let topMenuEl = $('.js-top-menu ul[data-depth="0"]');
  let dropDown = new DropDown(dropDownEl);
  let topMenu = new TopMenu(topMenuEl);

  dropDown.init();
  form.init();
  topMenu.init();

  linkDecrypt();
  lazyLoadImages();

  let ua = navigator.userAgent;
  if (ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1) {
    $('body').addClass('is-ie');
  }

  if (readCookie('cookieAccept') !== '1') {
    $('.js-cookies').show();
  }

  $('.js-accept-cookies').on('click', () => {
    createCookie('cookieAccept', '1', 365);
    $('.js-cookies').hide();
  })

});

const DOMobserver = new MutationObserver(() => {
  linkDecrypt();
  lazyLoadImages();
});

DOMobserver.observe(document.body, { childList: true, subtree: true });



// WEBPACK FOOTER //
// ./themes/maisondubillard/_dev/js/theme.js